import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Box } from "native-base";
import { colors, timeGridLinesHorizontalTop, timeGridLinesVerticalDashed, } from "./useStyles";
export default function TimeGridLines({ limits, timeData, evaluationBgHighlight, }) {
    const { timeCoords } = timeData;
    const { start, end } = evaluationBgHighlight;
    const { yMax, yMin } = limits;
    const isWithinDragSelectRange = (i) => start !== null && end !== null
        ? (i === start && i === end) ||
            (i >= Math.min(start, end) && i < Math.max(start, end))
        : false;
    return (_jsxs(_Fragment, { children: [timeCoords.map(({ x }, i) => (_jsx(Box, { style: timeGridLinesVerticalDashed, left: `${x}px`, top: "4px", bottom: "4px", width: `${i < timeCoords.length - 1 ? timeCoords[i + 1].x - x : 0}px`, backgroundColor: isWithinDragSelectRange(i)
                    ? `rgba(${colors.blue400Rgb}, 0.2)`
                    : colors.transparent }, `gridlines-${i}`))), _jsx(Box, { style: timeGridLinesHorizontalTop, left: 0, right: 0, top: `${yMax}px` }), _jsx(Box, { style: timeGridLinesHorizontalTop, left: 0, right: 0, top: `${yMin}px` }), _jsx(Box, { style: timeGridLinesHorizontalTop, left: 0, right: 0, top: `${(yMax + yMin) / 2}px` })] }));
}
